import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const OtherSkinDiseasesPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Various Skin Diseases</h1>
        <section className="mb-8">
          <p>We provide comprehensive natural treatment for a wide range of skin conditions, including dermatitis, hives, vitiligo, and other skin disorders. Our holistic approach focuses on addressing the root cause of skin problems while promoting natural healing and skin health through gentle, effective herbal remedies.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Common Skin Conditions We Treat</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Dermatitis</li>
            <li>Hives (Urticaria)</li>
            <li>Vitiligo</li>
            <li>Lichen Planus</li>
            <li>Skin Allergies</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Skin rashes and inflammation</li>
            <li>Itching and irritation</li>
            <li>Discoloration</li>
            <li>Dry or scaly patches</li>
            <li>Skin sensitivity</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use skin-healing herbs, detoxifying agents, and lifestyle modifications to naturally treat various skin conditions. Our approach focuses on improving skin health, reducing inflammation, and promoting natural healing through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural healing</li>
            <li>No harsh side effects</li>
            <li>Long-term results</li>
            <li>Improved overall skin health</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain proper skin hygiene</li>
            <li>Use gentle, natural skincare products</li>
            <li>Follow a balanced diet</li>
            <li>Manage stress levels</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Results vary by condition, but many patients notice improvement within 4-6 weeks of treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment suitable for sensitive skin?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for all skin types, including sensitive skin.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Will the treatment prevent recurrence?</strong>
            <p>A: Our holistic approach addresses underlying causes, helping to prevent recurrence of skin conditions.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from skin conditions—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default OtherSkinDiseasesPage; 